export function getOrderStatus(status: number) {
  switch (status) {
    case 0:
      return "Новый"
    case 1:
      return "Подтвержден"
    case 2:
      return "Завершен"
    case 3:
      return "Отменен"
    default:
      return ""
  }
}

export const modifyName = (name: string) => {
  if (name.includes("Запись подкастов")) {
    return "Студии записи подкастов"
  } else if (name.includes("Звукозапись")) {
    return "Студии звукозаписи"
  } else if (name.includes("Запись вебинара")) {
    return "Студии записи вебинара/курса"
  } else if (name.includes("коротких видео")) {
    return "Студии записи коротких видео для социальных сетей"
  }

  return name
}

export function getTaskStatusСolor(status: number) {
  switch (status) {
    case 0:
      return "#137bff"
    case 1:
      return "#07d300"
    case 2:
      return "#949494"
    default:
      return ""
  }
}

export function getOrderStatusСolor(status: number) {
  switch (status) {
    case 0:
      return "#ffeb13"
    case 1:
      return "#137aff"
    case 2:
      return "#19c80a"
    case 3:
      return "#c80a0a"
    default:
      return ""
  }
}

export function getReviewStatusСolor(status: number) {
  switch (status) {
    case 0:
      return "#ffeb13"
    case 1:
      return "#137aff"
    case 2:
      return "#19c80a"
    case 3:
      return "#c80a0a"
    default:
      return ""
  }
}